export default __webpack_public_path__ + "static/media/delivery.efd1152d.svg";